import { useMemo } from "react"
import { useVenue } from "providers/venue"
import pointInPolygon from "@turf/boolean-point-in-polygon"
import _ from "lodash"
import { IFeature } from "interfaces"
import { useDining } from "hooks/dining/useDining"

const anchorInSection = (anchor, section): Boolean =>
  pointInPolygon(anchor, section)

const LOVE_EAT_SECTION_NAME = "Love Eat"

export const useLoveEat = () => {
  const { occupants, sections } = useVenue()
  const loveEatSections: IFeature[] = useMemo(
    () =>
      sections.filter(
        (section: IFeature) =>
          section?.properties?.name?.en === LOVE_EAT_SECTION_NAME
      ),
    [sections]
  )

  const loveEatSectionGroupedByOrdinal = useMemo(
    () =>
      loveEatSections.reduce((sectionObj, section) => {
        const ordinal = _.get(section, "properties.ordinal")
        return {
          ...sectionObj,
          [ordinal]: section,
        }
      }, {}),
    [loveEatSections]
  )

  // Filter only occupant under Love Eat Zone
  const loveEatOccupants = useMemo(
    () =>
      occupants.filter((occupant) => {
        const anchor = _.get(occupant, "properties.anchor")
        const occupantOrdinal = _.get(occupant, "properties.ordinal")
        const loveEatSectionInSameOrdinal = _.get(
          loveEatSectionGroupedByOrdinal,
          occupantOrdinal,
          null
        )
        return (
          loveEatSectionInSameOrdinal &&
          anchorInSection(anchor, loveEatSectionInSameOrdinal)
        )
      }),
    [loveEatSectionGroupedByOrdinal, occupants]
  )

  const {
    restaurants,
    categories,
    currentCategory,
    levels,
    onChangeCategory,
    onChangeOrdinal,
  } = useDining(loveEatOccupants)

  const restaurantGroupedByLevel = useMemo(
    () => _.groupBy(restaurants, "properties.level_name"),
    [restaurants]
  )

  return {
    restaurants,
    restaurantGroupedByLevel,
    levels,
    categories,
    currentCategory,
    // Function
    onChangeCategory,
    onChangeOrdinal,
  }
}
